var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTriangleDownOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2109 6L4.78915 6L12 17.1262L19.2109 6ZM11.1842 19.5448L2.17591 5.6452C1.7243 4.94838 2.19458 4 2.99173 4H21.0083C21.8054 4 22.2757 4.94838 21.8241 5.64521L12.8158 19.5448C12.4224 20.1517 11.5776 20.1517 11.1842 19.5448Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleDownOutlined);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4yMTA5IDZMNC43ODkxNSA2TDEyIDE3LjEyNjJMMTkuMjEwOSA2Wk0xMS4xODQyIDE5LjU0NDhMMi4xNzU5MSA1LjY0NTJDMS43MjQzIDQuOTQ4MzggMi4xOTQ1OCA0IDIuOTkxNzMgNEgyMS4wMDgzQzIxLjgwNTQgNCAyMi4yNzU3IDQuOTQ4MzggMjEuODI0MSA1LjY0NTIxTDEyLjgxNTggMTkuNTQ0OEMxMi40MjI0IDIwLjE1MTcgMTEuNTc3NiAyMC4xNTE3IDExLjE4NDIgMTkuNTQ0OFoiIGZpbGw9IiMwNDA0MDUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };